import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import ActivateAccountForm from './ActivateAccountForm';
import { activateMemory } from '../../api/api';

export default class ActivateAccountPage extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      validResetPwd: false,
      errorMessage: '',
      spinner: 'inactive'
    }
  }

  onSubmit = (data) => {
    this.setState({ spinner: 'active' });
    data.userId = this.props.match.params.user;
    activateMemory(data).then((response) => {
      setTimeout(() => { this.setState({ spinner: 'inactive' }) }, 500);
        this.setState({ validResetPwd: true, errorMessage: '' });
    }, error => {
      this.setState({ errorMessage: 'Activation de compte chargé de mémoire refusé' });
      setTimeout(() => { this.setState({ spinner: 'inactive' }) }, 500);
      console.log(error);
    })

  };

  render() {
    return (
      <div className="login-main reset-page">
        <div className="page-background"></div>
        <div className="container login-container _activation">
          <div className="bloc-form">
            <h2>Activation de compte de chargé de mémoire </h2>
            {!this.state.validResetPwd ?
              <ActivateAccountForm
                onSubmit={this.onSubmit}
                spinner={this.state.spinner}
              />
              :
              <div className="bloc-from_success">
                <img src='/images/yes.png' alt="image" />
                <p className="validation-txt">
                  Votre mot de passe a bien été modifié. Vous pouvez maintenant
                  vous connecter à votre espace de recueil de mémoire.
                    </p>
                  <Link to="/charge-memoire-login"><button type="button" className="btn btn-primary btn-lg">Me connecter</button></Link>
              </div>
            }
            <div className="bloc-form_error">
              {this.state.errorMessage &&
                <div className="alert alert-danger single-line" role="alert">{this.state.errorMessage}</div>
              }
            </div>
          </div>
          <div className="signon-container">
            <div className="col-sm-5 text-bloc">
            	<h2>Compte actif ?</h2>
            	<p className>Vous avez été désigné comme chargé de mémoire. Pour activer votre compte, il est nécessaire de saisir le code d'activation reçu par mail et de choisir un mot de passe.</p>            
            </div>
          </div>
        </div>
      </div>
    )
  }
}





// WEBPACK FOOTER //
// ./src/components/ActivateAccount/ActivateAccountPage.js